var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "header-cell-style": _vm.$rowStyle.DEFAULT,
                "row-key": "BJ_EBC_ID",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "60",
                  align: "center",
                  label: _vm.$t("table.countText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  label: _vm.$t("OperatingUserText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "message",
                  label: _vm.$t("OperationContentText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "creationDate",
                  label: _vm.$t("OperatingTimeText"),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.hasApi
        ? _c(
            "BjPagingTable",
            {
              ref: "BjPagingTable",
              attrs: {
                "auto-fetch": true,
                api: _vm.tableApi,
                "default-params": _vm.defaultParams,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "60",
                  align: "center",
                  label: _vm.$t("table.countText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  label: _vm.$t("OperatingUserText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "message",
                  label: _vm.$t("OperationContentText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "creationDate",
                  label: _vm.$t("OperatingTimeText"),
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }